var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-tabs-items',{model:{value:(_vm.step),callback:function ($$v) {_vm.step=$$v},expression:"step"}},[_c('v-tab-item',[_c('EditPrivateProfile',{on:{"save":_vm.onPrivateProfileSave}})],1),_c('v-tab-item',[_c('EditPublicProfile')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }